var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-wardrobe-product-button-container"},[_c('b-button',{staticClass:"add-item-btn mb-5",attrs:{"size":"md","variant":_vm.variantName},on:{"click":function($event){return _vm.submit()}}},[_c('span',[_vm._v(_vm._s(_vm.buttonText))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-088f6e42","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wardrobe/buttons/CreateWardrobeOutfitButton.vue
// module id = BLn6
// module chunks = 0